// Fixed Assets Vuex

import state from './fixedAssetStates.js'
import * as getters from './fixedAssetGetters.js'
import * as mutations from './fixedAssetMutations.js'
import * as actions from './fixedAssetActions.js'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
